<template>
  <section>
    <textarea
        class="tcn-editor"
        id="text-area"
        ref="textarea"
        v-model="content"
        @keydown="showSuggestions"
    />
    <div v-show="showSuggestionList"
         ref="suggestionList"
         class="suggestion-list">
      <SuggestionsDropdownMarkdown ref="suggestionListComponent" @addText="addTextFromSuggestion" :items="filteredData"
                                   :char="suggestionChar"/>
    </div>
  </section>
</template>

<script>
import SuggestionsDropdownMarkdown from "./contentEditor/SuggestionsDropdownMarkdown.vue";

export default {
  name: "TecnaMarkdown",
  components: {SuggestionsDropdownMarkdown},
  props: {
    value: [Object, String],
    editor: [Object],
    configuration: [Object],
  },
  data() {
    return {
      showSuggestionList: false,
      suggestionChar: "",
      content: "",
      showMessage: false,
      filter: [],
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      },
    },
    async filteredData() {
      if (this.suggestionChar.includes('@')) {
        const query = this.model.substring(this.nearestOf("@", this.$refs.textarea) + 1)
        return this.configuration.usersSuggestion.dataSource(() => ({
                                                                      firstName,
                                                                      lastName,
                                                                      username
                                                                    }) => this.find(firstName, query) || this.find(lastName, query) || this.find(username, query));
      } else if (this.suggestionChar.includes('#')) {
        const query = this.model.substring(this.nearestOf("#", this.$refs.textarea) + 1)
        return this.configuration.filesSuggestion.dataSource(() => ({name}) => this.find(name, query));
      }
      return []
    },
  },
  watch: {
    content(newVal) {
      this.$emit("input", newVal)
    }
  },
  mounted() {
    console.log(this.editor.getMarkdown())
    this.content = this.editor.getMarkdown();
  },
  methods: {
    find(haystack, needle) {
      return String(haystack).toLocaleLowerCase().includes(String(needle).toLocaleLowerCase());
    },
    checkForUsername(event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        const regex = /\@\w+\b/g
        const text = event.target.value.substring(0, event.target.selectionStart)
        console.log(text)
        const match = text.match(regex)
        if (match) {
          const word = match[match.length - 1]
          const start = event.target.value.indexOf(word)
          const end = start + word.length

          if (event.target.selectionStart >= start && event.target.selectionStart <= end) {
            this.showMessage = true
            this.suggestionChar = '@';
            this.showSuggestionList = true
            this.filter = this.configuration.usersSuggestion.dataSource.filter(user => user.username.startsWith(word.substring(1)))
            this.setSuggestionListPosition()
          }
        }
      }
    },
    showSuggestions(event) {
      if (this.showSuggestionList === true && event.key === 'Escape') {
        this.showSuggestionList = false
      }
      if (this.showSuggestionList === true) {
        this.$refs.suggestionListComponent?.onKeyDown(event);
      }


      if (event.key.includes('@')) {
        this.suggestionChar = event.key;
        this.showSuggestionList = true
        this.setSuggestionListPosition()
      } else if (event.key.includes('#')) {
        this.suggestionChar = event.key;
        this.showSuggestionList = true
        this.setSuggestionListPosition()
      }
    },
    addTextFromSuggestion(data) {
      if (this.suggestionChar.includes('@')) {
        this.addUsername(data)
      } else if (this.suggestionChar.includes('#')) {
        this.addFileName(data)
      }
      this.showSuggestionList = false
    },
    addUsername(user) {
      const start = this.nearestOf("@", this.$refs.textarea) + 1
      const end = this.content.length
      this.content = this.content.slice(0, start) + user.username + this.content.slice(end)

    },
    addFileName(file) {
      const start = this.nearestOf("#", this.$refs.textarea) + 1
      const end = this.content.length
      this.content = this.content.slice(0, start) + file.name + this.content.slice(end)

    },


    setSuggestionListPosition() {
      const textarea = this.$refs.textarea
      const suggestionList = this.$refs.suggestionList
      const cursorPosition = textarea.selectionStart
      const textBeforeCursor = textarea.value.substring(0, cursorPosition)
      const linesBeforeCursor = textBeforeCursor.split('\n')
      const currentLine = linesBeforeCursor.length
      const currentLineStart = textBeforeCursor.lastIndexOf('\n') + 1
      const caretPosition = cursorPosition - currentLineStart
      suggestionList.style.top = `${(currentLine * 20) + 70}px`
      suggestionList.style.left = `${(caretPosition * 6) + 50}px`
    },
    nearestOf(char, textArea) {
      const text = textArea.value,
          origo = textArea.selectionStart,
          leftIndex = text.lastIndexOf(char, origo - 1),
          rightIndex = text.indexOf(char, origo);
      let distLeft, distRight, indices = {
        [distLeft = leftIndex < 0 ? Infinity : origo - leftIndex]: leftIndex,
        [distRight = rightIndex < 0 ? Infinity : rightIndex - origo + 2]: rightIndex
      };
      return indices[Math.min(distRight, distLeft)];
    }
  }
}
</script>

<style>
.suggestion-list {
  position: absolute;
  z-index: 1000;
}
</style>
